var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPclServiceSitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "m2.4 11.4 9.5-8.55 9.5 8.55h-2.85V19H5.25v-7.6H2.4m9.5 5.7.684-.627c2.451-2.223 4.066-3.686 4.066-5.481a2.587 2.587 0 0 0-2.612-2.613c-.827 0-1.616.39-2.138.997a2.857 2.857 0 0 0-2.138-.997 2.587 2.587 0 0 0-2.612 2.613c0 1.795 1.615 3.258 4.066 5.481l.684.627Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPclServiceSitter);
export default __webpack_public_path__ + "static/media/PclServiceSitter.016b17f8d4796d181c8ca2fb3077d7da.svg";
export { ForwardRef as ReactComponent };